<!--首页-->
<template>
  <div class="gray-back" style="height: 100%">
    <div class="box"  >
      <div class="news-content" style="padding: 0 10px;" v-html="row.content">
      </div>  
      </div>  


      <div class="course-box" >
        <div class="course-items" v-for="(item,i) in courseList" :key="i" @click="goCourseDetail(item.id)">
          <div class="course-pic-box">
            <img width="100%"  :src="item.pic_url" alt="">
            <span v-if="item.level">{{item.level}}</span>
          </div>
          <div class="course-title  ">{{item.title}}</div>
          <div class="course-price-box"><span class="course-price" v-if="item.price>0">¥{{ item.price }}</span><span class="course-num" v-if="item.video_count>0">{{item.video_count}}视频</span></div>
        </div>

      </div>
  </div>
</template>
<style scoped>

.course-price-box{
  display: flex;
  align-items: center;
}
.course-num{
  border: 1px solid rgba(255,71,104,1);;
  color:rgba(255,71,104,1);
  display: block;
  font-size: 10px;
  height: 14px;
  line-height: 14px;
  padding: 0 5px;
  margin-left: 5px;
  border-radius: 3px;
}
.course-price{
height:20px;
font-size:20px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:red;
line-height:20px;
}
.course-title{
font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:500;
color:rgba(0,0,0,1);
line-height:28px;

}
.course-pic-box span{
  position:absolute;
  display: block;
  padding: 0 10px;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  right: 0;
  border-radius: 0 10px 0 10px;
  color: #fff;
  font-size: 14px;
  height: 20px;
  overflow: hidden;
}
.course-pic-box img{
  /* height: 3.6rem; */
  object-fit: cover;
}
.course-pic-box {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
}
.course-items{
  /* width: 3.45rem; */
  margin-top: 0.2rem;
}
.course-box{
  width: 7.1rem;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.news-content>>>img{
  max-width: 100%;
}
.box {
  background: #f8f8f8;
  padding-bottom: 50px;
  overflow: hidden;
}
  .row1{
    /*padding: 10px;*/
    margin: 0 10px;
  }
  .row1 img{
    width: 100%;
    margin: 10px 0 0 0 ;
  }
  .row3{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 10px;
    flex-wrap: wrap;
  }
  .row3 img{
    float: left;
    width: calc(33.33% - 10px);
    /*margin: 0 10px 10px 0;*/
    margin: 0 0px 10px 0;
  }

</style>

<script>
import Vue from "vue";
import { Tab, Tabs, List, PullRefresh, Toast } from "vant";
Vue.use(Tab)
  .use(Tabs)
  .use(PullRefresh)
  .use(List)
  .use(Toast);

export default {
  name: "NewsList",
  components: {
  },

  data: function() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      active: 0,
      activeTab: [
      ],
      list:[],
      row:{
        content:''
      },
      params:{
        parent_id:1
      },
      courseList:[

      ]
    };
  },
  filters: {
  },
  mounted() {
    document.title = "331专题";
    this.fetch();
    this.getCourseList();
  },
  destroyed() {},
  methods: {
    fetch() {
      let that = this;
      that.$api.get(
              "/api/cms/detail",
              {
                id:425
              },
              res => {
                that.row = res.data.data
              },
              res => {
                Toast(res.msg);
              }
      );
    },
    goCourseDetail(id) {
      rbLink({
        name: 'CourseDetail',
        query: {
          id: id
        }
      })
    },
    getCourseList(){
      let that=this
      this.$api.get('/api/course/courseList',{
        cate_id:7,
        p:1,
        step:100
      },res => { 
            that.courseList = res.data.list; 
 
        },
        res => {
          Toast(res.msg);
        })
    },
  }
};
</script>



// WEBPACK FOOTER //
// 2022331.vue?60823cd6